/**
 * Local mock sign-in, for a browser harness that cannot hold a real session:
 * e2e/sage-shell.spec.ts runs against `NEXT_PUBLIC_USE_MOCK_AUTH=true npm run dev`.
 *
 * Only that environment flag turns it on, and never in a production build:
 * `next build` sets NODE_ENV=production, so every deployment (Vercel production
 * and preview alike) ignores the flag. Nothing a request carries (its host,
 * referer, query string or frame) can turn it on. The v0.dev preview mode this
 * replaces could: `?v0-preview` on any URL skipped the middleware's login,
 * admin and account-status gates.
 */
export function isMockAuthEnabled(): boolean {
  return process.env.NODE_ENV !== 'production' && process.env.NEXT_PUBLIC_USE_MOCK_AUTH === 'true'
}

/** The stand-in account mock auth signs in as. Never a person, and never a platform admin. */
export const MOCK_AUTH_USER = {
  id: 'mock-auth-user',
  email: 'mock-auth@maiteams.test',
  first_name: 'Mock',
  last_name: 'User',
} as const
